<template>
  <div class="home-hero-track" v-bind:class="getClass()" ref="hero">
    <span class="logo" @click="$router.push({ name: 'Home' })"></span>
    <div class="right-block" v-if="data.track">
      <h2 v-text="data.track.artist"></h2>
      <h1 v-text="data.track.title"></h1>
      <div class="play-circle">
        <span class="play-circle-1"></span>
        <!-- <a target="_blank" :href="getLink" @click="goLink($event)" class="play"></a> -->
        <button class="play" :class="{'playing': playing}" v-html="(playing) ? pauseSVG : playSVG" @click="togglePlay()"></button>
      </div>
      <audio v-show="false" ref="audio" v-if="trackSpotify.spotify">
        <source :src="previewUrl" type="audio/mpeg">
      </audio>      
      <div class="line"></div>
      <p class="release">{{ configs.released }} <strong v-text="getData"></strong></p>
      <p class="plays" v-if="data.track.plays"><strong v-text="getPlays"></strong> {{ configs.plays }}</p>
      <p class="call-to-action-container" v-if="data.call_to_action">
        <a class="call-to-action" :href="getLink" @click="goLink($event)">
          <strong>{{data.call_to_action_title}}</strong>
          <strong>{{data.call_to_action_title}}</strong>
        </a>
      </p>
    </div>
    <div class="circle" ref="circle" v-show="!data.embed"></div>
    <div class="background" v-bind:style="backgroundStyle()" v-show="!data.embed" ref="background"></div>
    <div class="iframe-background" v-if="data.embed" v-html="data.embed"></div>
    <div class="gradient" v-show="!data.embed"></div>

    <ul class="pagination-arrows" v-if="tracks.length > 1">
      <li class="arrow-left" @click="$emit('prevTrack')"><svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="15"/><circle cx="18" cy="18" r="15"/></svg><div><i></i><i class="hover"></i></div></li>
      <li class="arrow-right" @click="$emit('nextTrack')"><svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="15"/><circle cx="18" cy="18" r="15"/></svg><div><i></i><i class="hover"></i></div></li>
    </ul>

    <ul class="social">
      <li class="twitter"><a :href="social.twitter">Twitter</a></li>
      <li class="facebook"><a :href="social.facebook">Facebook</a></li>
    </ul>

    <div class="pagination" v-if="tracks.length > 1">
      <p>
        <span v-text="padLeft(index + 1)" class="current"></span>/<span v-text="padLeft(tracks.length)"></span> {{ configs.tracks }}
      </p>
      <ul>
          <li v-for="track in tracks" v-bind:key="track._id" v-bind:class="{active: current == track._id}">
              <a href="javascript:" @click="$emit('changeTrack', track._id);"></a>
          </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { TweenMax } from 'gsap'
import playSVG from '../../../../static/images/play.svg'
import pauseSVG from '../../../../static/images/pause.svg'

export default {
  name: 'HeroTrack',
  props: ['data', 'current', 'tracks', 'index'],
  dependencies: ['DATA'],
  data () {
    return {
      social: this.DATA.configs.social,
      configs: this.DATA.configs.hero,
      playing: false,
      playSVG: playSVG,
      pauseSVG: pauseSVG      
    }
  },
  computed: {
    getData () {
      return moment(this.data.track.realesed).format('MMMM, Do')
    },
    getPlays () {
      return this.data.track.plays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    getLink () {
      return (this.data.track.link) ? this.data.track.link : this.data.track.slug
    },
    previewUrl () {
      return process.env.API_URL + 'spotifyPreview/' + this.trackSpotify.spotify.replace('spotify:track:', '')
    },
    trackSpotify () {
      let track = this.DATA.tracks.filter((track) => {
        return track.slug === this.data.track.slug
      })
      if (track.length) {
        return track[0]
      } else {
        return null
      }
    }
  },
  mounted () {
    this.$refs['audio'].onpause = () => {
      this.playing = false
    }
    this.$refs['audio'].onplay = () => {
      this.playing = true
    }    
    this.$bus.$on('updateColors', (visible) => {
      this.updateColors()
    })
    this.timeout = setTimeout(() => {
      this.$el.addEventListener('mousemove', this.onMouseMove);
    }, 2000);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    if (this.$refs.audio) {
      this.$refs['audio'].pause();
    }
    this.$el.removeEventListener('mousemove', this.onMouseMove);
  },
  methods: {
    onMouseMove(evt) {
      // const rect = this.$el.getBoundingClientRect();
      const coef = (evt.clientX / window.innerWidth) - 0.5;
      TweenMax.to(this.$refs.background, 3, { x: coef * 50, ease: Quint.easeOut })
      TweenMax.to(this.$refs.circle, 3, { x: coef * 25, scaleX: 1 + Math.abs(coef * 0.1), ease: Quint.easeOut })
    },
    togglePlay () {
      if (this.playing) {
        this.$refs['audio'].pause()
        // this.$bus.$emit('spotify-player-resume')
      } else {
        this.$bus.$emit('spotify-player-pause')
        this.$refs['audio'].play()
      }
    },    
    updateColors () {
      if (!this.$refs['circle']) {
        return
      }
      let circle = window.getComputedStyle(this.$refs['circle'], null)
      let hero = window.getComputedStyle(this.$refs['hero'], null)
      this.$bus.$emit('setColors', circle.getPropertyValue('background-color'), hero.getPropertyValue('background-color'), '#000')
    },
    getClass () {
      let obj = {}
      obj[this.data.color] = true
      return obj
    },
    padLeft (value) {
      return (value < 10) ? '0' + value : value
    },
    backgroundStyle () {
      return {
        backgroundImage: `url(${this.data.background})`
      }
    },
    goLink ($event) {
      if ($event) event.preventDefault()
      if (!this.data.track.link) {
        this.$router.push({
          name: 'Track',
          params: {
            slug: this.data.track.slug
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../../scss/variables';
  @import '../../../scss/easing';

  @mixin render-color($color1name, $color1, $color2name, $color2, $textcolor) {
    &.#{$color1name}-#{$color2name} {
      background-color: $color1;
      color: $textcolor;
      .circle {
        background-color: $color2;
      }
      .social {
        background-color: $color2;
      }
      .right-block {
        .play-circle-1 {
          border-color: $color2;
          border-right-color: transparent;
        }
        .play {
          border: none;

          g {
            transform: scale(2);
            transform-origin: 45px 42px;
            fill: $textcolor;
          }

          &.playing {
            g {
              transform: scale(.3);
              transform-origin: 54px 54px;
            }
          }          
        }
        .play-circle {
          background-color: $color1;
          border-color: $color2;
        }
        .line {
          border-top-color: $color2;
        }
        p.call-to-action-container a.call-to-action {
          color: $textcolor !important;
          border-color: $color2 !important;
          background: $color1;
          strong:last-child {
            color: $textcolor;
            background: $color2;
          }
          strong:first-child {
            color: $textcolor !important;
            color: $color2;
          }
        }
      }
      .pagination-arrows {
        li {
          border-color: $color2;
          i {
            border-bottom-color: $color2;
            border-right-color: $color2;
          }
          svg {
            circle:first-child {
              stroke: $color2;
            }
          }
        }
      }
      .pagination {
        span.current {
          color: $color2;
        }
        a {
          border-color: $color2;
        }
        li.active a {
          background-color: $color2;
          border-color: $color2;
        }
      }
    }
  }

  .home-hero-track {
    height: 100vh;
    position: absolute;
    overflow: hidden;
    width: 100%;

    // @include render-color('black', $black, 'white', $white, $white);
    @include render-color('black', $black, 'red', $red, $white);
    @include render-color('black', $black, 'purple', $purple, $white);
    @include render-color('green', $green, 'pink', $pink, $black);
    @include render-color('purple', $purple, 'yellow', $yellow, $white);
    @include render-color('yellow', $yellow, 'pink', $pink, $black);
    @include render-color('blue', $blue, 'yellow', $yellow, $black);

    .logo {
      background-image: url('/static/images/logo.svg');
      background-repeat: no-repeat;
      background-size: contain;
      width: 202px;
      margin-top: -43px;
      height: 86px;
      position: absolute;
      top: 50%;
      left: 18%;
      z-index: 4;
      filter: invert(100%);
    }

    @media screen and (max-width: 1550px) {
      .logo {
        left: 5%;
      }
    }

    @media screen and (max-width: 64em) {
      .show-menu {
        margin-left: 0;
        left: 9%;
        top: 8%;
      }
      .logo {
        margin-top: 0;
        top: 5%;
        background-position: 50% 50%;
        left: 0;
        width: 100%;
        height: 10vw;
      }
    }

    .right-block {
      width: 30vw;
      position: absolute;
      margin-bottom: -24px;
      bottom: 50%;
      right: 0;

      h2 {
        font-family: $font-bold;
        font-size: 2vw;
        text-transform: uppercase;
      }

      h1 {
        font-family: $font-light;
        font-size: 3.6vw;
        padding-bottom: 18px;
      }

      p {
        position: absolute;
        left: 0;
        bottom: -1.8em;
        width: 100%;
        &.release {
          margin-top: 20px;
        }
        &.plays {
          margin-top: 10px;
          bottom: -2.9em;
        }
        font-size: 20px;
        strong {
          font-family: $font-bold;
        }
      }

      .play-circle {
        border: 2px solid;
        float: left;
        border-radius: 50%;
        position: relative;
        width: 42px;
        height: 42px;
      }

      @keyframes play-animation {
        0%   { transform: rotate(225deg); }
        100% { transform: rotate(-135deg); }
      }

      .play-circle-1 {
        border: 6px solid;
        position: absolute;
        padding: 22px 21px 14px 15px;
        border-radius: 50%;
        z-index: 1;
        top: -4px;
        border-right-color: transparent;
        left: -4px;
        animation: play-animation 2s infinite;
      }

      .play {
        border: 0;
        background: transparent;
        box-sizing: border-box;
        width: 0;
        height: 18px;
        display: block;

        border-top-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        cursor: pointer;

        z-index: 2;
        position: absolute;

        top: -2px;
        left: -2px;
        padding: 0;
        width: 44px;
        height: 44px;

        transition: transform .2s $easeOutBack;
        transform-origin: 55px 55px;
        overflow: hidden;

        svg {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 110px;
          height: 110px;
          margin-left: -32px;
          margin-top: -35px;
          transform: scale(0.5);
          transition: transform .2s $easeOutBack;
        }

        &:hover {
          svg {
            transform: scale(0.6);
          }
        }
      }

      @keyframes play-line-animation {
        0%   { width: 0%; }
        100% { width: calc(100% - 44px); }
      }

      .line {
        position: absolute;
        width: calc(100% - 44px);
        height: 0;
        border-top: 2px solid;
        margin-top: 21px;
        left: 44px;
        animation: play-line-animation 1s;
      }

      p.call-to-action-container {
        margin-bottom: -5em;
        a.call-to-action {
          border: 2px solid;
          font-size: 20px;
          font-family: $font-bold;
          outline: none;
          display: block;
          cursor: pointer;
          text-decoration: none;
          text-align: center;
          // padding: 20px 50px;
          position: relative;
          transition: background 0.3s $easeInOutQuint, transform 0.3s $easeOutBack;
          overflow: hidden;
          box-sizing: border-box;
          float: left;

          strong:last-child {
            position: absolute;
            top: 0px;
            left: 0px;
            padding: 20px 50px;
            opacity: 0;
            transform: translate3d(0px, 15px, 0px);
            transition: transform 0.3s $easeOutBack, opacity 0.3s linear;
            display: block;
            // display: none;
            padding-left: 51px;
            padding-right: 50px;
          }

          strong:first-child {
            position: relative;
            top: 0px;
            left: 0px;
            padding: 20px 50px;
            transition: transform 0.3s $easeOutBack, opacity 0.2s $easeOutBack;
            padding-left: 51px;
            padding-right: 50px;
            opacity: 1;
            display: block;
          }

          &:hover {
            color: transparent !important;
            strong:last-child {
              transform: translate3d(0px, 0px, 0px);
              opacity: 1;
            }
            strong:first-child {
              transform: translate3d(0px, -15px, 0px);
              opacity: 1;
            }
          }
        }
      }

      z-index: 4;
    }

    .background {
      width: 100%;
      height: 90vh;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: 50% 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
    }

    .iframe-background {
      width: 100%;
      height: 92vh;
      iframe {
        width: 100vw;
        height: 100vh;
      }
    }

    .gradient {
      background: linear-gradient(to bottom, rgba(0,0,0,0) 1%,rgba(0,0,0,0) 20%,rgba(0,0,0,0.65) 100%);
      width: 100%;
      height: 90vh;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 3;
    }

    .circle {
      height: 36vw;
      width: 36vw;
      margin-left: -18vw;
      margin-top: -18vw;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
    }

    .pagination-arrows {
      position: absolute;
      left: 50%;
      margin-left: -54px;
      bottom: 1.5%;
      z-index: 5;
      li {
        cursor: pointer;
        float: left;
        // border: 3px solid $white;
        height: 36px;
        width: 36px;
        border-radius: 50%;
        transition: transform 1s $easeOutBack;
        position: relative;

        div {
          transition: transform 1s $easeOutBack;
          transform-origin: 18px 18px;
        }

        svg {
          position: absolute;
          top: -3px;
          left: -3px;
          width: 42px;
          height: 42px;
          pointer-events: none;
          transform: rotate(-90deg);
          circle {
            fill: transparent;
            stroke: #fff;
            stroke-width: 3px;
          }
          circle:last-child {
            stroke-dasharray: 1000;
            stroke-dashoffset: 1000;
            transition: all 1s $easeInOutQuint;
          }
        }
        i {
          border-bottom: solid $white;
          border-right: solid $white;
          border-width: 0 3px 3px 0;
          display: inline-block;
          padding: 5px;
          margin-left: 14px;
          margin-top: 11px;
          transition: transform 0.3s $easeOutQuint, opacity 0.3s linear;
          pointer-events: none;

          &.hover {
            position: absolute;
            top: 0px;
            left: 0px;
            margin-top: 13px;
            margin-left: 12px;
            opacity: 0;
            border-color: white;
          }
        }
        &.arrow-left {
          margin-right: 19px;
          i {
            transform: rotate(135deg);
          }
          i.hover {
            transition: transform 0s $easeOutQuint, opacity 0s linear;
            transform: rotate(-135deg) translate3d(-5px, -5px, 0px);
          }
          svg {
            transform: scaleX(-1) rotate(-90deg);
          }
          &:hover {
            // transform: rotate(-90deg);
            div {
              transform: rotate(-90deg);
            }
            svg circle:last-child {
              stroke-dashoffset: 900;
            }
            i:not(.hover) {
              transform: rotate(135deg) translate3d(5px, 5px, 0px) scale(0.8);
              opacity: 0;
            }
            i.hover {
              opacity: 1;
              transition: transform 0.3s $easeOutQuint 0.2s, opacity 0.3s linear 0.2s;
              transform: rotate(-135deg) translate3d(0px, 0px, 0px);
            }
          }
        }
        &.arrow-right {
          i {
            transform: rotate(-45deg);
            margin-left: 10px;

            &.hover {
              transition: transform 0s $easeOutQuint, opacity 0s linear;
              transform: rotate(-135deg) translate3d(-5px, -5px, 0px);
              margin-left: 12px;
            }
          }
          &:hover {
            // transform: rotate(90deg);
            div {
              transform: rotate(90deg);
            }
            svg {
              transform: rotate(-90deg);
            }
            svg circle:last-child {
              stroke-dashoffset: 900;
            }
            i:not(.hover) {
              transform: rotate(-45deg) translate3d(5px, 5px, 0px) scale(0.8);
              opacity: 0;
            }
            i.hover {
              transition: transform 0.3s $easeOutQuint 0.2s, opacity 0.3s linear 0.2s;
              opacity: 1;
              transform: rotate(-135deg) translate3d(0px, 0px, 0px);
            }
          }
        }
      }
    }

    .social {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 4;
      width: 12.7%;
      padding: 2.5vh;
      li {
        float: right;
        text-indent: -99em;
        overflow: hidden;
        width: 25px;
        height: 25px;
        background-repeat: no-repeat;
        background-size: cover;
        margin: 0 20px 0 0;
        transition: all 0.2s linear;
        &:hover {
          filter: invert(100%);
        }
        a {
          display: block;
          width: 25px;
          height: 25px;
        }
      }
      .facebook {
        background-image: url('/static/images/facebook.svg');
      }
      .twitter {
        background-image: url('/static/images/twitter.svg');
      }
    }

    .pagination {
        position: absolute;
        right: 6.9%;
        bottom: 2.6%;
        p {
          font-size: 19px;
          color: $white;
          .current {
            letter-spacing: -4px;
            margin-left: -5px;
            font-size: 36px;
          }
        }
        li {
            float: left;
            a {
              margin-top: 1px;
              float: left;
              border: 2px solid;
              height: 6px;
              width: 6px;
              border-radius: 50%;
              margin-right: 4px;
            }
        }
        z-index: 4;
    }

    .fade-enter-active {
      transition: all .5s $easeInSine;
    }
    .fade-enter, .fade-leave-to {
      transform: scale(0.5);
      opacity: 0;
    }

    @media screen and (max-width: 64em) and (orientation:portrait) {
      .gradient {
        background: linear-gradient(to bottom, rgba(0,0,0,0) 1%,rgba(0,0,0,.5) 100%);
      }
      .circle {
        height: 200px;
        width: 200px;
        margin-left: 0;
        margin-top: 0;
        transform: translateX(-50%) translateY(-50%);
      }
      .right-block {
        width: 90%;
        h2 {
          font-size: 12px;
        }
        h1 {
          font-size: 26px;
        }
        h2, h1, p {
          color: $white;
        }
        p {
          font-size: 12px;
        }
        p.plays {
          margin-top: 0;
        }
        p.call-to-action-container {
          margin-bottom: -8em;

          a.call-to-action {
            padding: 10px 25px;
            font-size: 13px;
            strong {
              display: none;
            }
          }
        }
      }

      .social {
        width: 6%;
        display: none;
        li {
          margin: 0;
        }
      }

      .pagination-arrows {
        display: none;
      }

      .pagination {
        p {
          font-size: 14px;
          .current {
            letter-spacing: -3px;
            margin-left: 0;
            margin-right: 2px;
            font-size: 26px;
          }
        }
        li {
            a {
              margin-top: 1px;
              border: 2px solid;
              height: 6px;
              width: 6px;
              border-radius: 50%;
              margin-right: 4px;
            }
        }
      }

      .background {
        height: 75%;
      }

      .iframe-background {
        height: 53vh;
        iframe {
          height: 53vh;
        }
      }

      height: 60vh;

      .fade-enter-active {
        transition: none;
      }
    }

    @media screen and (max-width: 64em) {
      .social {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Hero/Track.vue